import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

import { ApiErrorResponse } from '../types.ts'

import { apiService } from './root.ts'
import { LOGIN_ROOT } from './login.ts'
import { MessageResponse } from './services.types.ts'
import { SBP_ROOT } from './sbp-payments.ts'
import { ACQ_ROOT } from './acquiring-payments.ts'

export const RESEND_ENDPOINTS = {
  resendLoginCode: `${LOGIN_ROOT}/resendingCode`,
  resendSbpCode: `${SBP_ROOT}/reverseConfirm`,
  resendAqcCode: `${ACQ_ROOT}/reverseConfirm`,
}

export const useResendCodeMutation = (login: string, apiUrl: string) =>
  useMutation<AxiosResponse<MessageResponse>, AxiosResponse<ApiErrorResponse>, void, unknown>({
    mutationFn: () => apiService.post<MessageResponse>(apiUrl, { bodyParams: { login } }),
  })
